<meter class="size-meter"
       [class.size-meter--amber]="tier() === 'amber'"
       [class.size-meter--red]="tier() === 'red'"
       [attr.aria-valuenow]="percent().toFixed(0)"
       aria-valuemin="0"
       aria-valuemax="100"
       [attr.aria-label]="ariaLabel()"
       value="{{ percent().toFixed(0) }}">
  <span class="size-meter-label" data-qa="size-meter-label">Size used: {{ usedMb() }}mb of {{ maxMb() }}mb</span>
  <div class="size-meter-segments">
    @for (segment of segments; track segment) {
      <div class="size-meter-segment" [class.filled]="segment < filledSegments()"></div>
    }
  </div>
</meter>
